const IdentityProvider = {
  Iam: "IAM",
  B2c: "B2C"
};

export default IdentityProvider;
